let LazyLoad = require('vanilla-lazyload');

export default class LazyLoadImages {
    constructor() {
        const lazyImages = $('.lazy');
        if(lazyImages.length) {
          return new LazyLoad();
        }
    }
}
